import { SingleQuestionDetailsProvider } from '@exam-management/question-creation-task-question-management';
import { useParams } from '@exam-management/router';
import { Flex } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function ItemSetQuestionsLayout() {
  const { taskId, subQuestionId } = useParams(
    '/task-management/question-creation/:taskId/item-set/:questionId/:subQuestionId',
  );

  return (
    <SingleQuestionDetailsProvider questionId={subQuestionId} taskId={taskId}>
      <Flex sx={{ flexDirection: 'column', height: '100%' }}>
        <Outlet />
      </Flex>
    </SingleQuestionDetailsProvider>
  );
}
